import { useMRT_TableInstance } from "./hooks/useMRT_TableInstance";
import { useMRT_TableOptions } from "./hooks/useMRT_TableOptions";
import { MRT_RowData, MRT_TableInstance, MRT_TableOptions } from "./types";

export const useMaterialReactTable = <TData extends MRT_RowData>(
  tableOptions: MRT_TableOptions<TData>
): MRT_TableInstance<TData> =>
  useMRT_TableInstance(useMRT_TableOptions(tableOptions));
